import './style.css';
import logoNegro from '../../img/logo.png';
import { Link } from 'react-router-dom';

function Menu(props) {
    return ( 
        <div className={`menu ${props.showMenu ? "menu-visible" : "menu-hidden"}`}>
            <div className="row rowLogo">
                <div className="col-4 col-sm-3 col-md-2 col-lg-1 m-0 p-0 d-flex">
                    <img src={logoNegro} alt="" width={'70%'} className='mb-0 mt-auto'/>
                </div>
                <div className="col-8 col-sm-9 col-md-10 col-lg-11"></div>
            </div>
            <div className="opciones">
                <Link className='opcionMenu' to={"/"} onClick={()=> props.setShowMenu(false)}>INICIO</Link>
                <Link className='opcionMenu' to={"/nosotros"} onClick={()=> props.setShowMenu(false)}>NOSOTROS</Link>
                <Link className='opcionMenu opcionNuestroTrabajo' to={"/nuestrotrabajo"} onClick={()=> props.setShowMenu(false)}>NUESTRO TRABAJO</Link>
                <Link className='opcionMenu' to={"/contacto"} onClick={()=> props.setShowMenu(false)}>CONTACTO</Link>
            </div>
        </div>
     );
}

export default Menu;